import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat, optionalBooleanFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const AnemiaTest: FC<ViewProps> = ({ result, editLink }) => {
  const item = result.regularHealthCheckupResultItems.find(item => item.itemCode === 'anemia_test');
  return (
    <Panel>
      <Link to={`${editLink}#anemia_test`}>
        <Headding icon={<Edit icon={16} />}>貧血検査</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>実施有無</Dt>
            <Dd>{optionalBooleanFormat(item?.checked ?? false, '有', '無')}</Dd>
          </Dl>
          <Dl>
            <Dt>結果</Dt>
            <Dd>{displayFormat(item?.value)}</Dd>
          </Dl>
          <Dl>
            <Dt>評価</Dt>
            <Dd>{displayFormat(item?.evaluation)}</Dd>
          </Dl>
          <Dl>
            <Dt>所見有無</Dt>
            <Dd>{optionalBooleanFormat(item?.hasFinding ?? false, '有', '無')}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
